import React, { useState } from 'react';
import { Tabs } from 'antd';
import FieldRow from './FieldRow';
import JsonPreview from './JsonPreview';
import { Field } from '../types';

const initialSchema: Field[] = [
  { key: '', type: 'string', value: '' }
];

// Utility functions for immutably updating the tree
function updateAt(tree: Field[], path: number[], newNode: Field): Field[] {
  if (path.length === 0) return [newNode];
  const [idx, ...rest] = path;
  return tree.map((node, i) =>
    i === idx
      ? rest.length
        ? { ...node, children: updateAt(node.children || [], rest, newNode) }
        : newNode
      : node
  );
}

function addAt(tree: Field[], path: number[], newNode: Field): Field[] {
  if (path.length === 0) return [...tree, newNode];
  const [idx, ...rest] = path;
  return tree.map((node, i) =>
    i === idx
      ? {
          ...node,
          children: rest.length
            ? addAt(node.children || [], rest, newNode)
            : [...(node.children || []), newNode],
        }
      : node
  );
}

function deleteAt(tree: Field[], path: number[]): Field[] {
  if (path.length === 1) {
    return tree.filter((_, i) => i !== path[0]);
  }
  const [idx, ...rest] = path;
  return tree.map((node, i) =>
    i === idx
      ? {
          ...node,
          children: deleteAt(node.children || [], rest),
        }
      : node
  );
}

const SchemaBuilder: React.FC = () => {
  const [schema, setSchema] = useState<Field[]>(initialSchema);

  const handleChange = (path: number[], newField: Field) => {
    setSchema((schema) => updateAt(schema, path, newField));
  };

  const handleAdd = (path: number[], newField: Field) => {
    setSchema((schema) => addAt(schema, path, newField));
  };

  const handleDelete = (path: number[]) => {
    setSchema((schema) => deleteAt(schema, path));
  };

  return (
    <Tabs
      defaultActiveKey="builder"
      items={[
        {
          key: 'builder',
          label: 'Builder',
          children: (
            <div>
              {schema.length === 0 && (
                <div>
                  <button
                    onClick={() =>
                      setSchema([{ key: '', type: 'string', value: '' }])
                    }
                  >
                    Add Field
                  </button>
                </div>
              )}
              {schema.map((field, idx) => (
                <FieldRow
                  key={idx}
                  field={field}
                  path={[idx]}
                  onChange={handleChange}
                  onAdd={handleAdd}
                  onDelete={handleDelete}
                />
              ))}
              <div style={{ marginTop: 10 }}>
                <button
                  onClick={() =>
                    setSchema(schema.concat([{ key: '', type: 'string', value: '' }]))
                  }
                >
                  Add Field
                </button>
              </div>
            </div>
          ),
        },
        {
          key: 'json',
          label: 'JSON',
          children: <JsonPreview schema={schema} />,
        },
      ]}
    />
  );
};

export default SchemaBuilder;
